<app-menu />

<main
  class="layout-content"
  [class.sidebar-collapsed]="isCollapsed"
>
  <button
    class="mobile-menu-btn"
    data-testid="layout-mobile-menu-button"
    (click)="openMobile()"
  >
    <span class="material-symbols-outlined">menu</span>
  </button>
  <router-outlet />
</main>
